import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'

import Dropzone from 'components/custom/FileDropzone/index'

const DropZoneContainer = (props) => {
  const {
    onDropAccepted,
    onDropRejected,
    maxSize,
    accept
  } = props

  return (
    <Dropzone 
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      maxSize={maxSize}
      accept={accept}
    >
    </Dropzone>
  )
}

export default DropZoneContainer

        